export const batchKeys = {
  all: ['batches'] as const,
  many: (queryProps?: Record<string, unknown>, type = 'list') =>
    [...batchKeys.all, type, ...[queryProps]].filter(Boolean),
};
